import { ProgramListItemActionButton } from 'elements/eventView/atomic/ProgramListItem/ProgramListItemActionButton';
import { useAnchorScroll } from 'hooks/general/useAnchorScroll';
import { useAnalytics } from 'libs/utils/site/analytics';
import { EVPcScrollAnchors } from 'pages/EventViewPage/EventViewPagePC/eVScrollAnchors';
import { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    markerId: string | null;
    title: string;
}

export const GoToMarkerButton = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const analytics = useAnalytics();
    const [searchParams, setSearchParams] = useSearchParams();
    const { scrollToAnchor } = useAnchorScroll();

    const { eventPath, isWide } = ctxEventView;
    const isMobile = !isWide;

    const navigate = useNavigate();

    function handleLocationClick() {
        analytics.track('event_ui.entity.go_to_marker.clicked', {
            markerId: props.markerId,
            title: props.title,
            type: 'program'
        });

        const mobileUrl = `/event/${eventPath}/map?markerId=${props.markerId}`;

        if (isMobile) {
            navigate(mobileUrl);
        } else {
            searchParams.set('markerId', props.markerId);
            searchParams.set('zoomTo', '1');
            setSearchParams(searchParams);
            scrollToAnchor(EVPcScrollAnchors.Map);
        }
    }

    if (!props.markerId) {
        return null;
    }

    return (
        <S_GoToMarkerButton className={props.className}>
            <ProgramListItemActionButton
                isWide={isWide}
                icon={['far', 'location-dot']}
                onClick={handleLocationClick}
            />
        </S_GoToMarkerButton>
    );
};

const S_GoToMarkerButton = styled.div``;
